<template>
    <div>
        <div class="home md:max-w-sm w-full p-4">
            <div class="p-6 bg-white rounded-lg border border-gray-200 shadow-md mb-4">
                <h1 class="text-xl">Le client accepte</h1>
                <div class="mt-2 border-b pb-4">
                    <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400" for="input-data">La conservation de ses données après réparation:</label>
                    <div class="flex justify-center">
                        <div class="mr-6">
                            <input v-model="radios.clientData" type="radio" id="data_storage_oui" name="data_storage" value="oui">
                            <label class="ml-2" for="data_storage_oui">Oui</label>
                        </div>
                        <div>
                            <input v-model="radios.clientData" type="radio" id="data_storage_non" name="data_storage" value="non">
                            <label class="ml-2" for="data_storage_non">Non</label>
                        </div>
                    </div>
                </div>
                <div class="mt-4 pb-2">
                    <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400" for="input-data">D'être recontacté:</label>
                    <div class="flex justify-center">
                        <div class="mr-6">
                            <input v-model="radios.clientAppel" type="radio" id="contact_oui" name="contact" value="oui">
                            <label class="ml-2" for="contact_oui">Oui</label>
                        </div>
                        <div>
                            <input v-model="radios.clientAppel" type="radio" id="contact_non" name="contact" value="non">
                            <label class="ml-2" for="contact_non">Non</label>
                        </div>
                    </div>
                </div>
            </div>

            <signatures v-if="defaultData" :mission-start="defaultData.date_create" v-model="signatures" :technicians="defaultData.tech" />

            <div class="flex items-center justify-center">
                <button :disabled="isSending" @click="$router.go(-1)" class="mr-1 text-white bg-slate-400 font-medium rounded-lg text-sm px-5 py-2.5 text-center" type="button">
                    Retour
                </button>

                <button :disabled="isSending" @click="formSubmit" class="ml-1 text-white bg-green-600 font-medium rounded-lg text-sm px-5 py-2.5 text-center" type="button">
                    <span v-if="!isSending">Envoyer</span>
                    <div class="flex items-center" v-if="isSending">
                        <spinner :display="true" spinner-class="fill-green-900 text-green-100 w-3.5 h-3.5 block mx-auto mr-2" />
                        Envoie..
                    </div>
                </button>
            </div>

            <!-- Alert no connexion -->
            <div v-if="waitingToSend && !hasConnexion" id="alert-additional-content-4" class="p-4 mb-4 bg-yellow-100 rounded-lg mt-4" role="alert">
                <div class="flex items-center">
                    <svg role="status" class="mr-2 w-4 h-4 text-yellow-500 fill-yellow-700 animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                    </svg>
                    <!-- <svg class="mr-2 w-5 h-5 text-yellow-700 dark:text-yellow-800" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg> -->
                    <h3 class="text-lg font-medium text-yellow-700">En attente de connexion..</h3>
                </div>
                <div class="mt-2 mb-4 text-sm text-yellow-700 text-left">
                    Vous n'avez pas de connexion, la donnée de votre formulaire est conservée jusqu'à son envoie.
                </div>
                <div class="flex">
                    <button @click="waitingToSend = false" type="button" class="text-yellow-700 bg-transparent border border-yellow-700 hover:bg-yellow-800 hover:text-white focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-xs px-3 py-1.5 text-center" data-dismiss-target="#alert-additional-content-4" aria-label="Close">
                        Annuler l'envoi
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Signatures from './Signatures.vue';
import ImageConversionTool from './../tools/ImageConversionTool'

import ApiFileService from '@/services/apiFile.service.js'
import ApiService from '@/services/api.service.js'

import Spinner from '@/components/Spinner.vue'

export default {
    components: {
        Signatures,
        Spinner
    },
    data() {
        return {
            form: null,
            defaultData: null,
            signatures: [],
            radios: {
                clientData: 'oui',
                clientAppel: 'oui'
            },
            isSending: false,
            hasConnexion: true,
            waitingToSend: false,
        }
    },
    watch: {
        waitingToSend: function(value) {
            // Scroll down to display warning message
            if (this.waitingToSend && !this.hasConnexion) {
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        let maxY = window.innerHeight;
                        window.scrollTo(0, maxY);
                    })
                })
            }
        },
    },
    computed: {
        checkSignatures() {
            return this.signatures && this.signatures.filter(sign => (sign.signature)).length == this.defaultData.tech.length + 1
        }
    },
    methods: {
        getStorageForm() {
            let form = localStorage.getItem('form-mobi')
            if (form) {
                this.form = JSON.parse(form)
                return this.form
            }
            return null
        },

        async storeSignatures() {
            if (this.checkSignatures) {
                this.signatures.forEach((signature) => {
                    let localStorageKeyname = 'signature-' + signature.type + (signature.technicien_id ? '-' + signature.technicien_id : '')
                    ImageConversionTool.storeImage(
                        localStorageKeyname,
                        signature.signature.blob
                    )
                    signature.localstorage_keyname = localStorageKeyname
                })
                return true
            }
        },

        async storeForm() {
            if (await this.getStorageForm()) {
                if (this.checkSignatures) {
                    // Store signatures
                    await this.storeSignatures()
                    // Store in localstorage
                    this.form['client-stock-data'] = this.radios.clientData
                    this.form['client-appel'] = this.radios.clientAppel
                    this.form['signature'] = this.signatures
                    localStorage.setItem('form-mobi', JSON.stringify(this.form))
                    return true
                } else {
                    this.$toast.error("Les signatures sont obligatoires");
                }
            }
            return false
        },

        async formSubmit() {
            if (await this.storeForm()) {
                // Send data
                if (this.hasConnexion) {
                    await this.uploadForm()
                } else {
                    this.waitingToSend = true
                }
            }
        },

        /*--------------
            Upload
        --------------*/

        async uploadSignatures() {
            if (this.getStorageForm()) {
                for (var index in this.form.signature) {
                    // Upload
                    let keyname = ImageConversionTool.transformKeyname(this.form.signature[index].localstorage_keyname)

                    if (localStorage.getItem(keyname)) {
                        let image = await ImageConversionTool.convertBase64ToBlob(localStorage.getItem(keyname))
                        let uploadImage = await ApiFileService.post({files: image.blob})
    
                        // Format signature object
                        this.form.signature[index].signature_id = uploadImage.data.files[0].id
                    }
                }
                localStorage.setItem('form-mobi', JSON.stringify(this.form))
                return true
            }
            return false
        },

        async uploadDraws() {
            if (this.getStorageForm()) {
                for (var index in localStorage) {
                    if (index.split('-')[0] == 'form_mobi_image_draw') {
                        if (localStorage[index]) {
                            let image = await ImageConversionTool.convertBase64ToBlob(localStorage[index])
                            let uploadImage = await ApiFileService.post({files: image.blob})
                            localStorage.removeItem(index)
                            this.form[index.split('-')[1]] = uploadImage.data.files[0].id
                        }
                    }
                }
                localStorage.setItem('form-mobi', JSON.stringify(this.form))
                return true
            }
            return false
        },

        async uploadForm() {
            if (this.getStorageForm()) {
                this.isSending = true

                if (this.hasConnexion) {
                    setTimeout(async () => {
                        await this.uploadDraws()
                        let signaturesHasUplaoded = await this.uploadSignatures()
                        if (!signaturesHasUplaoded) {
                            return
                        }
                        if (this.getStorageForm()) {
                            for (let key in this.form) {
                                if (typeof this.form[key] == 'object') {
                                    this.form[key] = JSON.stringify(this.form[key])
                                }
                            }
                            let response = await ApiService.post('submit_form', this.form)
                            if (response.data.posts.post) {
                                this.form = null
                                this.clearStorage()
                                window.location.replace(response.data.posts.post);
                            }
                        } else {
                            this.$toast.error('Une erreur est survenue')
                        }
                        this.isSending = false
                    }, 500)
                }
            } else {
                this.$toast.error('Une erreur est survenue')
            }
        },

        /*------------------
            Clear storage
        ------------------*/
        clearStorage() {
            localStorage.removeItem('form-mobi')
            localStorage.removeItem('form-mobi-default-data')

            // Remove image
            for (let key in localStorage) {
                if (key.split('-')[0] == 'form_mobi_image_signature' || key.split('-')[0] == 'form_mobi_image_draw') {
                    localStorage.removeItem(key)
                }
            }
        }
    },
    async mounted() {
        // Get localstorage data
        if (localStorage.getItem('form-mobi-default-data') && localStorage.getItem('form-mobi')) {
            this.defaultData = JSON.parse(localStorage.getItem('form-mobi-default-data'))
            this.getStorageForm()
        } else {
            if (localStorage.getItem('case_id')) {
                this.$router.push({name: 'form', params: {id: localStorage.getItem('case_id')}})
            } else {
                this.$toast.error('Une erreur est survenue')
            }
        }

        // Manage connexion
        this.hasConnexion = window.navigator.onLine

        window.addEventListener('online', () => {
            this.hasConnexion = true
            if (this.waitingToSend) {
                this.uploadForm()
            }
        });
        window.addEventListener('offline', () => {
            this.hasConnexion = false
        });
    }
}
</script>
